import { RootState } from 'store';

export const statisticsData = (state: RootState) => state.statisticsData;
